export default "__VITE_ASSET__B_GWRI53__"